/**
 * De smalle balk bovenin de pagina na een handeling: "Afgerond. Ongedaan
 * maken" of "Verstuurd om 14:02. Ongedaan maken". Staat tot het
 * ongedaan-venster sluit. Een fout bij ongedaan maken blijft staan.
 */
import { useState } from "react";

import { useNu } from "./tijd";

export interface MiddenMelding {
  /** Telt op per melding, zodat de balk opnieuw begint. */
  id: number;
  zaakId: string;
  tekst: string;
  /** ISO-moment waarop het venster sluit. */
  tot: string;
  /** Null: er valt niets terug te draaien. */
  ongedaan: (() => Promise<unknown>) | null;
  /** Motor 7 (keuze 7 van 75): het midden springt na versturen door; de
   *  melding (met Ongedaan maken) blijft dan staan bij de volgende zaak. */
  blijft?: boolean;
}

export function Meldingbalk({
  melding,
  onKlaar,
}: {
  melding: MiddenMelding;
  onKlaar: () => void;
}) {
  const nu = useNu(1000);
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState<string | null>(null);
  if (nu > new Date(melding.tot).getTime()) return null;

  const draaiTerug = async () => {
    if (!melding.ongedaan) return;
    setBezig(true);
    setFout(null);
    try {
      await melding.ongedaan();
      onKlaar();
    } catch {
      setFout("Ongedaan maken lukte niet. Probeer het opnieuw.");
      setBezig(false);
    }
  };

  return (
    <div className="v6-melding" role="status">
      <span>{melding.tekst}</span>
      {melding.ongedaan && (
        <button type="button" onClick={() => void draaiTerug()} disabled={bezig}>
          Ongedaan maken
        </button>
      )}
      {fout && <span className="v6-fout">{fout}</span>}
    </div>
  );
}
